import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop - returns the window to the top on every route change (bug 13).
 *
 * React Router preserves the window scroll offset across navigations, so
 * moving from a long page (Help, Pricing) to a shorter one leaves the new page
 * already scrolled partway down. Rendering this component once inside the
 * router fixes that everywhere instead of per page.
 *
 * Keyed on pathname only, so changing a query string or hash does not yank the
 * user back to the top of the page they are already reading.
 *
 * Renders nothing.
 */
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
